import { SNAPFLIX_FILE_NAMES, buildSnapflixVideoUrl } from '../config/snapflixVideos';
import { VideoContent } from '../types/video';

export interface LibraryVideo extends VideoContent {
  id: string;
  category: string;
}

const VIDEO_CATEGORIES = ['action', 'adventure', 'trailers', 'thriller'] as const;

const HOMEPAGE_CATEGORY_TITLES = [
  'TOP TRENDING VIDEOS',
  'ADVENTURE VIDEOS',
  'ACTION VIDEOS',
  'BRAIN TEASE VIDEOS',
  'FIGHTING VIDEOS',
] as const;

export const fileNameToTitle = (fileName: string): string =>
  fileName
    .replace(/\.mp4$/i, '')
    .replace(/^\d+\s*[-.]?\s*/, '')
    .trim();

const buildLibraryVideo = (fileName: string, index: number): LibraryVideo => {
  const video = buildSnapflixVideoUrl(fileName);

  return {
    id: `snapflix-${index}`,
    title: fileNameToTitle(fileName),
    video,
    image: video,
    category: VIDEO_CATEGORIES[index % VIDEO_CATEGORIES.length],
  };
};

export const SNAPFLIX_VIDEOS: LibraryVideo[] = SNAPFLIX_FILE_NAMES.map(buildLibraryVideo);

export const toVideoContent = (item: LibraryVideo | VideoContent): VideoContent => ({
  title: item.title,
  video: item.video,
  image: item.image || item.video,
});

export const getCarouselVideos = (count = 5): VideoContent[] =>
  SNAPFLIX_VIDEOS.slice(0, count).map(toVideoContent);

export const getHomepageCategories = () =>
  HOMEPAGE_CATEGORY_TITLES.map((title, index) => ({
    title,
    games: SNAPFLIX_VIDEOS.slice(index * 4, index * 4 + 4).map((item) => ({
      name: item.title,
      video: item.video,
      image: item.image,
    })),
  }));

export const getVideosPageItems = () =>
  SNAPFLIX_VIDEOS.map((item, index) => ({
    id: index + 1,
    title: item.title,
    category: item.category,
    video: item.video,
    image: item.image,
  }));

export const getAllVideosForFavorites = (): Array<LibraryVideo & { category: string; name: string }> =>
  SNAPFLIX_VIDEOS.map((item) => ({
    ...item,
    name: item.title,
    category: item.category,
  }));

export const getVideosSectionItems = (count = 8): VideoContent[] =>
  SNAPFLIX_VIDEOS.slice(5, 5 + count).map(toVideoContent);
